import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";

/**
 * Adds a random UUID to the "X-BTMID" header of an Axios request configuration.
 *
 * @param {InternalAxiosRequestConfig} config - The Axios request configuration to modify.
 * @return {InternalAxiosRequestConfig} The modified Axios request configuration.
 */
export const btmIdInterceptor = (config: InternalAxiosRequestConfig) => {
    // https://github.com/axios/axios/issues/5573#issuecomment-1644862647
    config.headers ??= {} as AxiosRequestHeaders;
    try {
        config.headers["X-BTMID"] = crypto.randomUUID();
    } catch {}

    return config;
};

export const addBtmIdInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(btmIdInterceptor, null, { synchronous: true });
};
